import React, { useState } from 'react';
import { Tooltip, Space } from 'antd';

const ShortenId = ({ value }) => {
  const [isCopy, setIsCopy] = useState(false);

  const copyToClipboard = async (id) => {
    try {
      await navigator?.clipboard?.writeText(id);
      setIsCopy(true);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const shortenString = (str, maxLength) => {
    if (!str) return 'N/A';
    if (str?.length <= maxLength) return str;

    const firstChars = str?.substring(0, Math?.floor(maxLength / 2));
    const lastChars = str?.substring(str?.length - Math?.floor(maxLength / 2));
    return `${firstChars}...${lastChars}`;
  };

  const stringValue = value ?? '';

  return (
    <Tooltip
      onOpenChange={() => setIsCopy(false)}
      title={
        <div style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(stringValue)}>
          <Tooltip title={isCopy ? 'Copied' : 'Click to Copy'}>{stringValue}</Tooltip>
        </div>
      }>
      <Space style={{ cursor: 'pointer' }}>{shortenString(stringValue, 20)}</Space>
    </Tooltip>
  );
};

export default ShortenId;
